module.exports = {"nav":{"langChange":"Cambia el idioma","lang":"Idioma","translate":"Traducir"}};